module.exports = __webpack_public_path__ + "static/media/1012241.f0a782c5.jpg";